import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData, getPressMedia} from '../utils/endpoints'
import { Container } from 'react-bootstrap';
import Loading from './components/loading';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Header from './components/header';
import Footer from './components/footer';
import { Helmet } from 'react-helmet';

const FaqPage = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const [pressMediaData, setPressMediaData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const pressMediaData = await getPressMedia(id);
            setPressMediaData(pressMediaData);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
        return <div>Error: {error.message}</div>;
      }

  return (
    <div>
      <Helmet>
      <title>Detailed Information and Queries Answered | State of Belief</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
          <Container>
          <ul>
                <li><a href="/">Home</a></li>
                <li>FAQ's</li>
            </ul>
            <h1>FAQ's</h1>
          </Container>
        </section>
        <div className='faQPageWrapper'>
        <Faqs compData={faqs} />
        </div>
      
      <Footer />
    </div>
  );
};

export default FaqPage;